import {
  ControlService,
  GapShorthandValue,
  StyleDefinition,
} from '../../types';
import { Padding } from '@wix/document-services-types/src/style/layout';
import { StyleVariableValueValue } from '@wix/document-services-types';

import {
  findSharedValue,
  getShorthandStyleValues,
  getStyleValue,
} from '../../common/valueResolverService';
import {
  isSpacingStyleValue,
  isPaddingValue,
  isGapShorthandValue,
} from '../../common/valueResolverService/valueGuards';

function getValidNumericValues<
  T extends Padding['top'] | GapShorthandValue['columnGap'],
>(values: T[]): number[] {
  return (
    values
      .filter(
        (v): v is Extract<T, { type: 'Length' }> =>
          // @ts-expect-error - TODO: ds-types-bump
          v !== undefined && v.type === 'Length',
      )
      // @ts-expect-error - TODO: ds-types-bump
      .map((value) => value.value)
  );
}

function areAllValuesSame(values: number[]): boolean {
  return values.length > 0 && values.every((value) => value === values[0]);
}

function returnSharedValue(values: number[]): number | undefined {
  return areAllValuesSame(values) ? values[0] : undefined;
}

function getCommonShorthandNumericValue(
  value: Padding | GapShorthandValue,
): number | undefined {
  let validValues: number[];

  // @ts-expect-error - TODO: ds-types-bump
  if (isPaddingValue(value)) {
    const { top, left, right, bottom } = value;
    validValues = getValidNumericValues([top, left, right, bottom]);
    return returnSharedValue(validValues);
  }

  if (isGapShorthandValue(value)) {
    const { columnGap, rowGap } = value;
    validValues = getValidNumericValues([columnGap, rowGap]);
    return returnSharedValue(validValues);
  }

  return undefined;
}

export function getSingleNumericValue(
  value: StyleVariableValueValue | undefined,
) {
  if (isSpacingStyleValue(value)) {
    // @ts-expect-error - TODO: ds-types-bump
    return value.value;
  }
  return undefined;
}

export const findSharedStylesNumericValue = (
  styles: ControlService['styles'],
  styleDefinitions: ControlService['styleDefinitions'],
  styleIds: string[],
): number | undefined => {
  return findSharedValue(
    styleIds,
    (styleId) => {
      const reader = new ValueReader(
        styles[styleId],
        styleDefinitions[styleId],
      );
      return reader.findSharedNumericValue();
    },
    (currentValue, sharedValue) => currentValue === sharedValue,
  );
};

class ValueReader {
  private shorthandValue?: ReturnType<typeof getShorthandStyleValues>;
  private value?: ReturnType<typeof getStyleValue>;
  constructor(
    styleObject: { value: StyleVariableValueValue } | undefined,
    styleDefinition: StyleDefinition,
  ) {
    this.shorthandValue = getShorthandStyleValues(styleObject, styleDefinition);
    this.value = getStyleValue(styleObject, styleDefinition);
  }

  findSharedNumericValue() {
    if (this.shorthandValue) {
      return getCommonShorthandNumericValue(this.shorthandValue);
    }
    return getSingleNumericValue(this.value);
  }
}
